// import Register from '../Components/Register.js'
import Cover from '../Components/Cover.js'
import Header from '../Components/Header';
import Event from '../Components/Event';
import { Container,Row,Col } from 'reactstrap';
import {ToastContainer} from "react-toastify";
import Footer from '../Components/Footer';
// import firebase from "firebase/app";
// import firebaseConfig from "../Config/Firebase";
import Fade from 'react-reveal/Fade';

// if (!firebase.apps.length) {
// firebase.initializeApp(firebaseConfig);
// }else {
// firebase.app(); 
// }

function Main() {
return (
    <div>

    <div className="entire">
        <Header></Header>
        <ToastContainer position="top-center"></ToastContainer>
        <Cover></Cover>
    </div>

    <div className="sectiontwo py-2">

        <div className="event my-2" id="event">
        <Fade><h3 className="my-5 title text-center">Tech Events</h3></Fade>
        <Container> 
            <Row>
            <Col sm="6" className="my-2">
                <Event
                    event="Paperzentó"
                    info="Paper Presentation - The secret of getting ahead is getting started. Grab the opportunity to present your ideas and take your first step"
                    text= {"RULES:\n1. Presentations must be in the domain of ECE and BME \n 2. A team can have two members \n 3. Soft copy of project details should be submitted during registration \n  4. Time limit: 5-10 mins \n 5. Participants can use PowerPoint/Slide presentations to present their topics \n 6. Decision of the jury will be final"}
                    name="Ragavi"
                    no="6385593309"
                    name1="J.Issac Shelton"
                    no1="8760891136"
                    // link="https://forms.gle/ob57Q6ubxGRkbvhT9"
                    >
                </Event>
            </Col>
            <Col sm="6" className="my-2">
                <Event 
                    event="Circúfitz"
                    info="Circuit Designing - Circuits aren't significant unless their designs are upgraded further. Upgrade circuit designs just like technology uplifts our life."
                    text={"RULES:\n1. Participants must take part individually \n 2. The event will be held via Google meet, Kahoot and Tinkercad \n 3. Two rounds will be conducted \n  Qualifying round: MCQ(Based on electronics) in Kahoot \n  Second round: Complete and name the circuit given in Tinkercad \n Tiebreaker: Build a perfect circuit in Tinkercad \n 4. Decision of the Jury will be the final \n 5. Join 15 minutes early for a mock training in Tinkercad"}
                    name="Anees"
                    no="6369366985"
                    name1="Sneha V"
                    no1="9489173462"
                    // link="https://forms.gle/Czwev83zxBGH7ihr5"
                    >
                </Event>
            </Col>
            <Col sm="6" className="my-2">
                <Event 
                    event="PresentÚrs"
                    info="Project Presentation - Do you have a mind-blowing concept which you can't wait to present? Here is an event that allows you to bestow your project to the mass."
                    text={"RULES:\n1. Participants can participate in a Team of 2 \n 2. Presentation topic must be in the domain of ECE and BME \n 3. A working prototype or a video is mandatory \n 4. Soft copy of the presentation should be submitted during registration \n 5. Presenting time must be within 5-10 mins \n 6. Participants can use a powerpoint / slide presentation for explaining \n 7. Decision of the jury will be final"}
                    name="Anees"
                    no="6369366985"
                    name1="Gananathan K"
                    no1="9080436837"
                    // link="https://forms.gle/zEcCpSSvhwAZs6mW6"
                    >
                </Event>              
            </Col>
            <Col sm="6" className="my-2">
                <Event 
                    event="Codéfy"
                    info="Coding challenge - Anyone can write codes that a computer can understand but, only a good programmer can make codes that humans can understand"
                    text={"RULES:\n1. Participants must take part individually \n 2. Two challenges are to be faced \n Round 1: Quiz (  Platform: Kahoot , Duration: 10 minutes) \n Round 2: Code solution for the given problem ( Platform: Hackerrank, Multiple submission is permitted ) \n 3. Challenges are based on algorithm and data structure \n 4. Code with preferable language \n 5. Rank is allotted based on scores obtained \n 6. Wrongdoing leads to disqualification"}
                    name="Ragavi"
                    no="6385593309"
                    name1="M.Muthulakshmi"
                    no1="8344454083"
                    // link="https://forms.gle/QY7bBBGRCrpMjgzY9"
                    >
                </Event>
            </Col>
            </Row>
        </Container>
        </div>
        
        <div className="event my-2" id="ntevent">
        <Fade><h3 className="my-5 title text-center">Non Tech Events</h3></Fade>
        <Container> 
            <Row>
            <Col md="3" className="my-2">
                <Event 
                    event="Framešpot"
                    text={"RULES:\n1. Participants must take part individually \n 2. Last date for registration is 07/05/2021 \n 3. There will be two rounds which will be in Google meet and Kahoot \n 4. Make sure to have a Kahoot account \n 5. The difficulty increases with the level \n 6. Questions are exclusively from Kollywood/Tamil Movies \n 7. Winners will be decided based on the performance and score from Kahoot"}
                    img= {require("../assets/movie.svg")}
                    name="Jayavalli"
                    no="7358430018"
                    name1="Reehan Roshan.A"
                    no1="8778954039"
                    // link="https://forms.gle/2iK5dc2Vpi8vtEN78"
                    >
                </Event>
            </Col>
            <Col md="3" className="my-2">
                <Event 
                    event="Comíquiz"
                    text={"RULES:\n1. Quiz will be based on Marvel and DC movies \n 2. Participants must take part individually \n 3. Last date for registration: 07/05/2021 \n 4. Two rounds will be held on google meet with the help of Kahoot and buzzin.live \n 5. Top 10 will be shortlisted for the final round \n 6. Winners will be selected on the basis of maximum points scored \n 7.  Any sort of malpractice will be disqualified"}
                    img= {require("../assets/mdc.svg")}
                    name="Naveen Raj"
                    no="8610258120"
                    name1="RohithNarayan"
                    no1="9444552572"
                    // link="https://forms.gle/a6imS9pbQhumJN38A"
                    >
                </Event>
            </Col>
            <Col md="3" className="my-2 mx-auto">
                <Event 
                    event="PiĈachu"
                    text={"RULES:\n1. Theme: Open theme \n 2. Only 1 entry from a participant is allowed \n 3. Usage of mobile phones and DSLRs are permitted \n 4. Basic editing is allowed, provided these do not affect the authenticity of the photo \n 5. Watermark is prohibited \n 6. Deadline: 5th may, 2021 \n 7. Submit your entries during registration \n 8. Shortlisting is based on the number of likes \n 9. Decision of the jury is final"}
                    img= {require("../assets/cam.svg")}
                    name="Jayavalli"
                    no="7358430018"
                    name1="Reshma K"
                    no1="8939758248"
                    // link="https://forms.gle/3iXF8UnXXNFNJhSF6"
                    >
                </Event>              
            </Col>
            <Col md="3" className="my-2 mx-auto">
                <Event 
                    event="VALÕRANT"
                    text={"RULES:\n 1. Participants should participate in a team of 5 \n 2. One registration per team \n 3. Participants can be from the same or different college \n 4. Registered team must have a discord account \n 5. Maps will be selected through lots \n 6. Matches will be conducted through knockout rounds \n 7. Incase of bug abuse or hacks the team will be disqualified \n 8. No spectators are allowed \n 9. Registration ends on 6th May 2021"}
                    img= {require("../assets/game.svg")}
                    name="Surenthar"
                    no="6382925962"
                    name1="Sri Mohnish K J"
                    no1="6385156334"
                    cost="  ₹100 /-  Per Team"
                    // link="https://forms.gle/6SWik7iQHECzej7S7"
                    >
                </Event>              
            </Col>
            </Row>
        </Container>
        </div>

        <div className="event my-2 mb-5" id="workshop">
        <Fade><h3 className="my-5 title text-center">Workshops</h3></Fade>
        <Container> 
            <Row>
            <Col sm="4" className="my-2">
            <Event 
                    event="PCB Designing"
                    info="Design Your Circuit Board Today!"
                    text={"Learn how to design a schematic diagram using various softwares and convert it into a physical circuit board layout. Now start transforming mere circuitry into a creative one."}
                    name="Kishore"
                    no="7094342727"
                    cost="  ₹100 /-"
                    // link="https://forms.gle/9Eu4F58uo88z1VmBA"
                    >
            </Event>
            </Col>
            <Col sm="4" className="my-2">
            <Event
                    event="Internet Of Things"
                    info="Learn the New Revolution Of The Internet"
                    text={"Alter the past, Innovate the future! Let us connect devices to the internet to make the foundation of the world cleverer. Spare your time with us to make things smart out of zilch."}
                    name="Madhesh"
                    no="7338987338"
                    cost="  ₹100 /-"
                    // link="https://forms.gle/9Eu4F58uo88z1VmBA"
                    >
                </Event>
            </Col>
            <Col sm="4" className="my-2">
                <Event 
                    event="Biopotential Measurements and Electrophysiology"
                    info="Let's get attracted to human facts just like ions get attracted to each other"
                    text={"Join us to cognize how exciting the electrochemical activity of an excitable cell can be, along with fascinating facts to know the body's potentials and functions and pump the flow of adrenaline through your bloodstream."}
                    name="Parthasarathy S"
                    no="6380514022"
                    cost="  ₹50 /-"
                    // link="https://docs.google.com/forms/d/e/1FAIpQLSfwAOknPZOTCR-DJVqTTn30HrtgLaXf6XQMCKMF1By_AaKwxg/viewform"
                    >
                </Event>              
            </Col>
            </Row>
        </Container>
        </div>    

        {/* <div className="reg my-2" id="reg">
        <Fade><h3 className="my-5 title text-center">Registration Opening <h1>Soon !</h1> </h3></Fade>
        <Container>
            <Register></Register>
        </Container>
        </div> */}
        
    </div>
    <Footer></Footer>
    </div>
);
}

export default Main;
